import { Typography } from '@/shared/components/atoms';
import CircularBgImage from '@/shared/components/atoms/CircularBgImage';
import MiniComponentContainer from '@/shared/components/atoms/MiniComponentContainer';
import TippyTooltip from '@/shared/components/atoms/TippyTooltip';
import { IPartialListWithTooltipProps } from '@/shared/components/molecules/PartialListWithTooltip/IPartialListWithTooltip';
import { clsxm } from '@/shared/lib';

const PartialListWithTooltip: React.FC<IPartialListWithTooltipProps> = ({
  items,
  limit = 1,
  background = 'light',
  itemClassName,
  containerClassName,
  contentClassName,
  hasBorder = true,
  imgProps = {
    size: 'md',
  },
}) => {
  return (
    <div className={clsxm('flex gap-1', containerClassName)}>
      {items.slice(0, limit).map((item, idx) => (
        <MiniComponentContainer
          hasBorder={hasBorder}
          key={`${item.description}-${idx}`}
          className='text-12 font-semi-bold text-text-default'
        >
          {item.imageURL && (
            <CircularBgImage imageSrc={item.imageURL} {...imgProps} />
          )}
          <span>{item.description}</span>
        </MiniComponentContainer>
      ))}
      {items.slice(limit, items.length).length > 0 && (
        <TippyTooltip
          content={
            <div className={clsxm('flex flex-col gap-2', contentClassName)}>
              {items.slice(limit, items.length).map((item, idx) => (
                <MiniComponentContainer
                  key={`tooltip-${item.description}-${idx}`}
                  className={clsxm(
                    'text-12 font-semi-bold text-text-default',
                    itemClassName
                  )}
                  hasBorder={hasBorder}
                >
                  {item.imageURL && (
                    <CircularBgImage imageSrc={item.imageURL} {...imgProps} />
                  )}
                  <Typography variant='subtitle2'>
                    {item.description}
                  </Typography>
                </MiniComponentContainer>
              ))}
            </div>
          }
          theme={background}
        >
          <MiniComponentContainer className='h-full cursor-pointer text-12 font-semi-bold text-text-default'>
            <span>+{items.slice(limit, items.length).length}</span>
          </MiniComponentContainer>
        </TippyTooltip>
      )}
    </div>
  );
};

export default PartialListWithTooltip;
